/**
 * cache.js - Utilitaire de cache sessionStorage
 *
 * Permet aux composants d'afficher instantanément les données précédemment
 * chargées (effet "snap"), tout en rafraîchissant en arrière-plan.
 *
 * Le cache est purgé automatiquement à la fermeture de l'onglet.
 */

const PREFIX = 'mp_cache_';

export const cacheGet = (key, defaultValue = null) => {
  try {
    const raw = sessionStorage.getItem(PREFIX + key);
    return raw ? JSON.parse(raw) : defaultValue;
  } catch (_) {
    return defaultValue;
  }
};

export const cacheSet = (key, value) => {
  try {
    sessionStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch (_) {
    // ignore (quota exceeded, private mode…)
  }
};

export const cacheRemove = (key) => {
  try {
    sessionStorage.removeItem(PREFIX + key);
  } catch (_) {}
};

export const cacheClearAll = () => {
  try {
    Object.keys(sessionStorage)
      .filter((k) => k.startsWith(PREFIX))
      .forEach((k) => sessionStorage.removeItem(k));
  } catch (_) {}
};
